export default __webpack_public_path__ + "static/media/bsc.2907f46c.svg";